import { SWRConfiguration } from 'swr';

import { ProfileContracts } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/data/contracts';
import { useSWR } from '~/hooks/useSWR';

import { getContracts } from './data';

export const useContracts = (
  profileId: number,
  swrConfig?: SWRConfiguration,
  disabled?: boolean,
) => {
  const { data, isLoading, error } = useSWR<ProfileContracts>(
    !disabled ? ['contracts', profileId] : null,
    () => getContracts(profileId),
    { revalidateOnFocus: false, ...swrConfig },
  );

  const noData: ProfileContracts = {
    contracts: [],
    profile: { firstName: '', lastName: '' },
  };

  return {
    data: data ?? noData,
    isLoading,
    error,
  };
};
